import { types as t } from 'mobx-state-tree';
import { ModalStore } from 'shared/modals/ModalStore';
import { CompanyStore } from './CompanyStore';
import { JobStore } from './JobStore';
import { UIStore } from './UIStore';

const AppStore = t.model('AppStore', {
  companyStore: CompanyStore,
  jobStore: JobStore,
  uiStore: UIStore,
  modalStore: ModalStore,
});

export default AppStore;
